export const API_URL = process.env.REACT_APP_API_URL;

export const SEARCH_ENDPOINT1_URL = process.env.REACT_APP_SEARCH_ENDPOINT1_URL;
export const SEARCH_ENDPOINT1_KEY = process.env.REACT_APP_SEARCH_ENDPOINT1_KEY;
export const SEARCH_ENDPOINT1_HOST =
  process.env.REACT_APP_SEARCH_ENDPOINT1_HOST;

export const SEARCH_ENGINE_ID = process.env.REACT_APP_SEARCH_ENGINE_ID;
export const SEARCH_ENGINE_API_KEY =
  process.env.REACT_APP_SEARCH_ENGINE_API_KEY;
export const SEARCH_ENGINE_API_URL = `${process.env.REACT_APP_SEARCH_ENGINE_API_BASE_URL}?key=${SEARCH_ENGINE_API_KEY}&cx=${SEARCH_ENGINE_ID}`;
export const SEARCH_ENGINE_PUBLIC_URL =
  process.env.REACT_APP_SEARCH_ENGINE_PUBLIC_URL;

export const SEARCH_ON = process.env.REACT_APP_SEARCH_ON==="true";
